import { motion, type MotionProps } from "framer-motion";
import { forwardRef } from "react";
import { useBackgroundColor } from "@tennr/frontend/context";

interface DynamicTextProps extends MotionProps {
  as?: keyof JSX.IntrinsicElements;
  children: React.ReactNode;
  fadeInDelay?: number;
}

export const DynamicText = forwardRef<HTMLElement, DynamicTextProps>(
  ({ as = "span", children, style, transition, fadeInDelay = 0, className, ...props }, ref) => {
    const { getContrastingColor } = useBackgroundColor();
    const textColor = getContrastingColor();

    // Get the correct motion component
    const Component = motion[as as keyof typeof motion] as any;

    return (
      <Component
        ref={ref}
        className={className}
        style={{ color: textColor, ...style }}
        transition={{
          duration: 0.4,
          ease: [0.3, 1, 0.7, 1],
          delay: fadeInDelay,
          ...transition,
        }}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

DynamicText.displayName = "DynamicText";
